const STORAGE_KEY = 'last_used_user_email';

export const getLastUsedUserEmail = (): string | null => localStorage.getItem(STORAGE_KEY);

export const setLastUsedUserEmail = (email: string): void => localStorage.setItem(STORAGE_KEY, email);

export const clearLastUsedUserEmail = (): void => localStorage.removeItem(STORAGE_KEY);
